<template>
    <div v-if="field">
        <b-form-textarea 
        :id="field.key" 
        :placeholder="field.constraints.placeholder"
        v-model="content"
        autocomplete="off"
        v-bind="$attrs"
        ></b-form-textarea>
         <b-form-invalid-feedback :id="field.key" style="display:block">
          {{ errors[0] || null }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
export default {
    name: "IdentityField_Text",
    props: {
        field: {
            type: Object
        },
        value: {
            type: String,
            default: ""
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: []
        }
    },
    computed: {
        content: {
            get() {
                if (this.value == "") {
                    return this.constraints.default || ""
                }

                return this.value;
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    methods: {
        check(val) {
            val = val || ""
            
            this.errors = []

            if (val == "" && this.constraints.required) {
                 this.errors.push(this.translator("identityField.requiredField"))
            }
            
            if (this.constraints.length.max !== null && this.constraints.length.max > 0) {
                if (val.length > this.constraints.length.max && val.length > 0) {
                    this.errors.push(
                        this.translator("identityField.cantBeMoreThenChars", {
                            max: this.constraints.length.max
                        })
                    )
                }
            }
            
            if (this.constraints.length.min !== null) {
                if (val.length < this.constraints.length.min && val.length > 0) {
                    this.errors.push(
                        this.translator("identityField.cantBeLessThenChars", {
                            min: this.constraints.length.min
                        })
                    )
                }
            }
            
            
            if (this.constraints.not_allowed_words !== undefined) {
                let notAllowedWords = this.constraints.not_allowed_words.split(",")
                notAllowedWords.forEach(word => {
                    word = word.trim()

                    if (word != "") {
                        if (val.indexOf(word) !== -1) {
                            this.errors.push(
                                this.translator("identityField.wordNotAllowed", {
                                    word: word
                                })
                            )
                        }  
                    }              
                })
            }

            if (this.constraints.regex !== undefined || this.constraints.regex !== "") {
                let re = new RegExp(this.constraints.regex)
                if (! re.test(val)) {
                    this.errors.push(this.translator("identityField.invalidInput"))
                }
            }
                
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        }
    },
    mounted() {
        this.check(this.content)
    }
    }
</script>